import { Navigate, Outlet } from 'react-router';
import { useSession } from '@/features/auth';
import AppLoadingScreen from '@/shared/ui/AppLoadingScreen';

const ProtectedRoute = () => {
  const { user, loading } = useSession();

  // Mostra loading durante la verifica
  if (loading) {
    return <AppLoadingScreen message="Verifica accesso…" />;
  }

  // Se non c'è utente = non autenticato
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Utente autenticato = mostra contenuto
  return <Outlet />;
};

export default ProtectedRoute;
